import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'
import styles from '../../styles'

const Footer = ({
  classes,
  onConfirm,
  onClose,
  isCanBeConfirmed,
  isCodesUploading,
}) => {
  return (
    <div>
      <Button
        className={cn(classes.button, classes.filledButton)}
        onClick={onConfirm}
        variant="contained"
        disabled={!isCanBeConfirmed || isCodesUploading}
      >
        {isCodesUploading ? <CircularProgress size={20} /> : null} Confirm
      </Button>
      <Button
        className={classes.button}
        variant="outlined"
        onClick={onClose}
        disabled={isCodesUploading}
      >
        Cancel
      </Button>
    </div>
  )
}
export default withStyles(styles)(Footer)
